<template>
    <!--
     Tailwind UI Centered Page Numbers
     Still want to show the "showing 1 to 10 of 97 results" somewhere
     https://tailwindui.com/components/application-ui/navigation/pagination#component-f9a9347de5384a492c79c34cf6ce3ccf
     -->
    <nav    v-if="show"
            class="border-t border-gray-200 px-4 pb-2 flex items-center justify-between sm:px-0">
        <div class="w-0 flex-1 flex pl-4">
            <span   v-show="canPrevious"
                    @click="$emit('update:page', page - 1)"
                    class="cursor-pointer -mt-px border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-md leading-5 font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400">
                <!-- Heroicon name: arrow-narrow-left -->
                <svg class="mr-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                </svg>
                Previous
            </span>
        </div>
        <div class="hidden md:flex text-md">
            <div    v-for="(pageNum, pageIndex) in pages"
                    class="">
                <span   v-if="pages[pageIndex - 1] + 1 !== pageNum && pageNum !== 1"
                        class="-mt-px border-t-2 border-transparent pt-4 px-4 inline-flex items-center leading-5 font-medium text-gray-500">
                ...
                </span>
                <span   @click="$emit('update:page', pageNum)"
                        :class="(pageNum === page ? 'border-indigo-500' :
                            'border-transparent hover:border-gray-300 hover:text-gray-700') +
                            ' cursor-pointer -mt-px border-t-2 pt-4 px-4 inline-flex items-center leading-5 font-medium ' +
                            'text-gray-500 focus:outline-none ' +
                            'focus:text-gray-700 focus:border-gray-400 transition ease-in-out duration-150'">
                    {{ pageNum }}
                </span>
            </div>
        </div>
        <div class="w-0 pr-4 flex-1 flex justify-end">
            <span   v-show="canNext"
                    @click="$emit('update:page', page + 1)"
                    class="cursor-pointer -mt-px border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-md leading-5 font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400">
                Next
                <!-- Heroicon name: arrow-narrow-right -->
                <svg class="ml-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </span>
        </div>
    </nav>

</template>

<script>

export default {
    name: "Pagination",
    mixins: [],
    components: {},
    props: {
        numPages: Number,
        page: Number,
        showPages: {
            type: Number,
            default: 7,
        },
    },
    data() {
        return {
            pages: [],
        }
    },
    mounted() {
        this.updatePages()
    },
    methods: {
        updatePages() {
            // If the pages are not setup, take no action to update
            if (_.isNil(this.numPages) || _.isNil(this.maxPages)) {
                return
            }
            let pages = new Array(Math.min(this.maxPages, this.numPages))
            let centerPoint = this.center
            if (!this.canCenterPage) {
                if (this.numPages - this.page - 1 <= 1) {
                    centerPoint = this.maxPages - (this.numPages - this.page) - 1
                }
                else {
                    centerPoint = this.page - 1
                }
            }

            pages[centerPoint] = this.page
            if (centerPoint > 1) {
                pages[centerPoint - 1] = this.previous
            }
            if (centerPoint < this.maxPages - 1) {
                pages[centerPoint + 1] = this.next
            }


            pages[0] = 1
            pages[pages.length - 1] = this.numPages

            for (let index = 1; index <= this.center; index++) {
                this.calculatePageNumber(pages, index)
                this.calculatePageNumber(pages, this.maxPages - index - 1)
            }

            this.pages = pages
        },
        calculatePageNumber(arr, index) {
            if (_.isNil(arr[index])) {
                if (index <= this.center) {
                    arr[index] = arr[index - 1] + 1
                }
                else {
                    arr[index] = arr[index + 1] - 1
                }
            }
        }
    },
    watch: {
        page() {
            this.updatePages()
        },
        maxPages() {
            this.updatePages()
        },
        numPages() {
            this.updatePages()
        },

    },
    computed: {
        show() {
            return this.numPages > 1
        },
        canPrevious() {
            return this.page > 1
        },
        canNext() {
            return this.page < this.numPages
        },
        next() {
            return Math.min(this.page + 1, this.numPages)
        },
        previous() {
            return Math.max(this.page - 1, 1)
        },
        center() {
            return Math.floor(this.maxPages / 2)
        },
        canCenterPage() {
            return this.numPages - this.page - 1 > 1 &&
                   this.page - 2 > 1
        },
        maxPages() {
            return Math.min(this.showPages, this.numPages)
        }
    },
}
</script>

<style scoped>

</style>
